import { useState } from "react";
import SteppedModal from "./SteppedModal";
import Button from "ui/buttons/Button";
import Input from "ui/forms/Input";

## Basic Usage

export function BasicSteppedModal() {
  const [open, setOpen] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const steps = ["Details", "Settings", "Review"];
  const handleClose = () => {
    setOpen(false);
    setStepIndex(0);
  };
  const handleNext = () => {
    if (stepIndex < steps.length - 1) {
      setStepIndex(stepIndex + 1);
    } else {
      alert("Form submitted!");
      handleClose();
    }
  };
  const handleBack = () => {
    if (stepIndex > 0) {
      setStepIndex(stepIndex - 1);
    }
  };
  return (
    <>
      <Button onClick={() => setOpen(true)}>Open Stepped Modal</Button>
      {open && (
        <SteppedModal
          headerText={`Step ${stepIndex + 1}: ${steps[stepIndex]}`}
          steps={steps}
          stepIndex={stepIndex}
          onClickNext={handleNext}
          onClickBack={handleBack}
          onClose={handleClose}
          canProceed
        >
          {stepIndex === 0 && (
            <div>
              <p style={{ marginBottom: "1rem" }}>Enter your project details:</p>
              <Input placeholder="Project name" />
            </div>
          )}
          {stepIndex === 1 && (
            <div>
              <p style={{ marginBottom: "1rem" }}>Configure your settings:</p>
              <label style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                <input type="checkbox" defaultChecked />
                Enable notifications
              </label>
            </div>
          )}
          {stepIndex === 2 && (
            <div>
              <p>Review your information and click Submit to finish.</p>
            </div>
          )}
        </SteppedModal>
      )}
    </>
  );
}

<BasicSteppedModal />

---

## With Validation

export function ValidatedSteppedModal() {
  const [open, setOpen] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const steps = ["Name", "Email", "Confirm"];
  const canProceed = () => {
    if (stepIndex === 0) return name.trim().length > 0;
    if (stepIndex === 1) return email.includes("@");
    return true;
  };
  const handleClose = () => {
    setOpen(false);
    setStepIndex(0);
    setName("");
    setEmail("");
  };
  const handleNext = () => {
    if (stepIndex < steps.length - 1) {
      setStepIndex(stepIndex + 1);
    } else {
      alert(`Submitted: ${name}, ${email}`);
      handleClose();
    }
  };
  return (
    <>
      <Button onClick={() => setOpen(true)}>Open Validated Modal</Button>
      {open && (
        <SteppedModal
          headerText={steps[stepIndex]}
          steps={steps}
          stepIndex={stepIndex}
          onClickNext={handleNext}
          onClickBack={() => setStepIndex(Math.max(0, stepIndex - 1))}
          onClose={handleClose}
          canProceed={canProceed()}
        >
          {stepIndex === 0 && (
            <div>
              <p style={{ marginBottom: "0.5rem" }}>Enter your name:</p>
              <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" />
              {!name && <p style={{ fontSize: "0.75rem", color: "#ef4444", marginTop: "0.25rem" }}>Name is required</p>}
            </div>
          )}
          {stepIndex === 1 && (
            <div>
              <p style={{ marginBottom: "0.5rem" }}>Enter your email:</p>
              <Input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" type="email" />
              {email && !email.includes("@") && <p style={{ fontSize: "0.75rem", color: "#ef4444", marginTop: "0.25rem" }}>Invalid email</p>}
            </div>
          )}
          {stepIndex === 2 && (
            <div>
              <p style={{ marginBottom: "0.5rem" }}>Please confirm your details:</p>
              <p><strong>Name:</strong> {name}</p>
              <p><strong>Email:</strong> {email}</p>
            </div>
          )}
        </SteppedModal>
      )}
    </>
  );
}

<ValidatedSteppedModal />

---

## Different Sizes

export function LargeSteppedModal() {
  const [open, setOpen] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const steps = ["Step 1", "Step 2"];
  return (
    <>
      <Button onClick={() => setOpen(true)}>Open Large Modal</Button>
      {open && (
        <SteppedModal
          headerText={steps[stepIndex]}
          steps={steps}
          stepIndex={stepIndex}
          onClickNext={() => stepIndex < 1 ? setStepIndex(1) : (alert("Done!"), setOpen(false), setStepIndex(0))}
          onClickBack={() => setStepIndex(0)}
          onClose={() => { setOpen(false); setStepIndex(0); }}
          canProceed
          size="large"
        >
          <p>This is a larger stepped modal for more content.</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        </SteppedModal>
      )}
    </>
  );
}

<LargeSteppedModal />

